var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.documents),function(document){return _c('documents-item-vue',{key:document.id})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }